(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
// Animation on scroll
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  });

  document.querySelectorAll('.animation1, .animation2').forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-video"] && !Shopify.designMode) return;
  try {
    
// Animation on scroll
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  });

  document.querySelectorAll('.animation1, .animation2').forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products"] && !Shopify.designMode) return;
  try {
    
// Animation on scroll
document.addEventListener('DOMContentLoaded', () => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
      }
    });
  });

  document.querySelectorAll('.animation1, .animation2').forEach((el) => observer.observe(el));
});

  } catch(e) { console.error(e); }
})();
})();
